export function getOpenSeaUrl(blockchain_name: string, collection_key: string, token_id?: string): string {
    const getBlockchainPath = (name: string): string => {
        const blockchainMap: { [key: string]: string } = {
            'AVALANCHE FUJI': 'avalanche-fuji',
            'SEPOLIA': 'sepolia',
            'POLYGON': 'matic',
            'ETHEREUM': 'ethereum',
        };
        
        return blockchainMap[name.toUpperCase()] || 'sepolia';
    };

    const blockchainPath = getBlockchainPath(blockchain_name);
    const baseUrl = `https://testnets.opensea.io/assets/${blockchainPath}/${collection_key}`;
    
    return token_id ? `${baseUrl}/${token_id}` : baseUrl;
}